import React, { useContext } from "react";
import { Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

import Card from "../../../components/Card";

import { useLocalization } from "../../../../context/LocalizeContextProvider";
import InputField from "../../../components/InputField";
import Button from "../../../components/Button";
import { optionsFilterDuration } from "../../../../utils/constants";
import { handleWhatsAppMessage } from "../../../../utils/utils";
import Table from "../../../components/Table";
import { ThemeContext } from "../../../../context/ThemeContext";
import WrapperStatus from "../../../components/WrapperStatus";

export default function PatientPackageComponents({
  handleChangeFilter = () => undefined,
  handleClearFilter = () => undefined,
  handleClickFilter = () => undefined,
  handlePagination = () => undefined,
  handleChangeSizePerPage = () => undefined,
  isLoading = false,
  filterPackage,
  dataPatientPackage = [],
  activePage,
  totalPage = 0,
  totalEntries = 0,
}) {
  const localize = useLocalization();
  const { nameClinic } = useContext(ThemeContext);

  const formatInputDate =
    optionsFilterDuration.find(
      (item) => item.value === filterPackage?.type?.value
    )?.format || "DD-MM-YYYY";

  const columns = [
    { label: localize.getText("namePatient") },
    { label: localize.getText("identityNumber") },
    { label: localize.getText("namePackage") },
    { label: localize.getText("lastReservation") },
    { label: localize.getText("remainingNumberOfVisit") },
    { label: localize.getText("phoneNumber") },
    { label: localize.getText("dateOfBirth") },
    {
      label: localize.getText("action"),
      className: "text-center",
    },
  ];

  return (
    <div>
      <Card title="FILTER DATA PAKET PASIEN">
        <div className="d-flex flex-column" style={{ gap: 32 }}>
          <Row style={{ rowGap: 18 }}>
            <Col md={4}>
              <InputField
                label={localize.getText("identityNumber")}
                placeholder={localize.getText("placeholderField", {
                  fieldName: localize.getText("identityNumber"),
                })}
                onChange={(value) =>
                  handleChangeFilter("identity_number", value)
                }
                value={filterPackage?.identity_number || null}
                fullWidth
                isBorder
              />
            </Col>
            <Col md={4}>
              <InputField
                type="date"
                views={[filterPackage?.type?.value || "day"]}
                format={formatInputDate}
                label={localize.getText("from")}
                onChange={(value) => handleChangeFilter("from", value)}
                value={filterPackage?.from || null}
                fullWidth
                disableHighlightToday
                isBorder
                classNameInput="date-picker-search"
              />
            </Col>
            <Col md={4}>
              <InputField
                type="date"
                views={[filterPackage?.type?.value || "day"]}
                format={formatInputDate}
                label={localize.getText("to")}
                value={filterPackage?.to || null}
                onChange={(value) => handleChangeFilter("to", value)}
                shouldDisableYear={(year) => {
                  return year.isBefore(filterPackage?.from);
                }}
                shouldDisableMonth={(month) => {
                  return month.isBefore(filterPackage?.from);
                }}
                shouldDisableDate={(date) => {
                  return date.isBefore(filterPackage?.from);
                }}
                disabled={!filterPackage?.from}
                fullWidth
                disableHighlightToday
                isEndField
                isBorder
                classNameInput="date-picker-search"
              />
            </Col>
          </Row>
          <Row style={{ rowGap: 18 }}>
            <Col md={4}>
              <InputField
                label={localize.getText("name")}
                placeholder={localize.getText("placeholderField", {
                  fieldName: localize.getText("name"),
                })}
                onChange={(value) => handleChangeFilter("name", value)}
                value={filterPackage?.name || null}
                fullWidth
                isBorder
              />
            </Col>
            <Col md={4}>
              <InputField
                label={localize.getText("phoneNumber")}
                placeholder={localize.getText("placeholderField", {
                  fieldName: localize.getText("phoneNumber"),
                })}
                onChange={(value) => handleChangeFilter("phone_number", value)}
                value={filterPackage?.phone_number || null}
                fullWidth
                isBorder
              />
            </Col>
            <Col md={4}>
              <InputField
                type="date"
                format={formatInputDate}
                label={localize.getText("dateOfBirth")}
                onChange={(value) => handleChangeFilter("date_of_birth", value)}
                value={filterPackage?.date_of_birth || null}
                fullWidth
                isBorder
                classNameInput="date-picker-search"
              />
            </Col>
          </Row>
          <div className="d-flex gap-4 justify-content-end">
            <Button
              label={localize.getText("search")}
              onClick={handleClickFilter}
            />
            <Button
              label={localize.getText("reset")}
              variant="danger"
              onClick={handleClearFilter}
            />
          </div>
        </div>
      </Card>
      <Card>
        <Table
          columns={columns}
          loading={isLoading}
          activePage={filterPackage?.page}
          totalPage={totalPage}
          totalShow={dataPatientPackage?.length}
          totalEntries={totalEntries}
          sizePerPage={filterPackage?.size}
          handlePagination={handlePagination}
          handleSizePerPage={handleChangeSizePerPage}
        >
          {dataPatientPackage.map((item, index) => (
            <tr key={index}>
              <td>{item?.name || "-"}</td>
              <td>{item?.identity_number || "-"}</td>
              <td>{item.package_name || "-"}</td>
              <td>
                <div className="d-flex flex-column gap-2">
                  {item.isMoreThanOneMonth && (
                    <WrapperStatus
                      icon="fas fa-exclamation-triangle"
                      label="> 1 Bulan"
                      background="#ED8030"
                    />
                  )}
                  {item?.last_reservation_date || "-"}
                </div>
              </td>
              <td>{item?.remaining_visits || "-"}</td>
              <td>
                <div className="d-flex flex-column gap-2">
                  {item?.phone_number && (
                    <WrapperStatus
                      icon="fab fa-whatsapp"
                      label="Hubungi"
                      background="#09BD3C"
                      onClick={() =>
                        handleWhatsAppMessage(
                          item.phone_number,
                          `Halo, kami dari ${nameClinic} ingin menginformasikan bahwa Anda belum menggunakan paket "${item.package_name}" selama lebih dari satu bulan. Apakah Anda ingin membuat reservasi?`
                        )
                      }
                    />
                  )}
                  {item?.phone_number || "-"}
                </div>
              </td>
              <td>{item?.date_of_birth || "-"}</td>
              <td>
                <div className="d-flex justify-content-center gap-3">
                  <Link
                    to={{
                      pathname: "/patient-package/detail-patient-package",
                      search: `?id=${item.package_id}`,
                    }}
                  >
                    <Button variant="warning">
                      <i className="fas fa-eye"></i>
                    </Button>
                  </Link>
                </div>
              </td>
            </tr>
          ))}
        </Table>
      </Card>
    </div>
  );
}
